import { render, staticRenderFns } from "./IlamsizNafakaAlacakForm.vue?vue&type=template&id=18cf3281"
import script from "./IlamsizNafakaAlacakForm.vue?vue&type=script&lang=ts"
export * from "./IlamsizNafakaAlacakForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports